export default __webpack_public_path__ + "media/elisa.949cb229.jpg";